import api from './api';

async function guardarRespuestaPregunta(id_item_evaluacion, id_pregunta_item, respuesta) {
  return api.put(
    `/api/informes/respuestas/pregunta/${id_item_evaluacion}/${id_pregunta_item}`,
    { respuesta }
  );
}

async function getByEvaluacion(evaluacionId) {
  return api.get(
    `/api/informes/respuestas/pregunta?item=${encodeURIComponent(evaluacionId)}`
  );
}

const respuestaService = {
  guardarRespuestaPregunta,
  getByEvaluacion,
};

export default respuestaService;

//https://opeva-dev.jphlions.com/api/informes/respuestas/pregunta/78/40

//"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MywibGVnYWpvIjoiSlBIMDAzODc4OTMwMiIsIm5vbWJyZSI6IkFndXN0aW4gTWVuZGV6IiwiZW1haWwiOiJ0ZXN0MDFAdHJwLmNvbS5hciIsInJvbGVzIjpbImV2YWx1YWRvciJdLCJwZXJtaXNvcyI6WyJ2ZXJfaW5mb3JtZXMiLCJjcmVhcl9pbmZvcm1lIiwicmVzcG9uZGVyX2V2YWx1YWNpb24iXSwidGVuYW50IjoidGVuYW50X2EiLCJpYXQiOjE3ODI5MDk0NTUsImV4cCI6MTc4MjkzODI1NX0.lEnI5teEMrHO9xo8QURUN5MZiO8b8_zEmOrdHHhn8WY"

